import { useTranslation } from 'react-i18next'

import { CardDashboard, CardContent, Badge } from '@percent/lemonade'
import type { Account } from '@percent/domain/iam'

const nullStyle = { color: 'var(--content-disabled, #b6b4b9)' }

type ContactIdentityCardProps = {
  account: Account
}

export function ContactIdentityCard({ account }: ContactIdentityCardProps) {
  const { t } = useTranslation()
  const notSet = <span style={nullStyle}>{t('typography.nullValue')}</span>

  return (
    <CardDashboard title={t('memberProfile.contactIdentity')} headingLevel="h4">
      <CardContent title={t('form.fullName')} testId="contact-fullName">
        {account.fullName || notSet}
      </CardContent>
      <CardContent title={t('memberProfile.preferredName')} testId="contact-preferredName">
        {account.preferredName || notSet}
      </CardContent>
      <CardContent title={t('memberProfile.email')} testId="contact-email">
        <a href={`mailto:${account.email}`}>{account.email}</a>
      </CardContent>
      <CardContent title={t('memberProfile.phoneNumber')} testId="contact-phoneNumber">
        {account.phoneNumber || notSet}
      </CardContent>
      <CardContent title={t('memberProfile.accountId')} testId="contact-accountId">
        <Badge variant="default">{account.id}</Badge>
      </CardContent>
    </CardDashboard>
  )
}
